"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { transferCart } from "@lib/data/customer";
import { ExclamationCircleSolid } from "@medusajs/icons";
import { StoreCart, StoreCustomer } from "@medusajs/types";
import { Button } from "@medusajs/ui";
import { useState } from "react";
function CartMismatchBanner(props) {
  const $ = _c(17);
  const t = useTranslations("store");
  const {
    customer,
    cart
  } = props;
  const [isPending, setIsPending] = useState(false);
  let t0;
  if ($[0] !== t) {
    t0 = t("Run transfer again");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [actionText, setActionText] = useState(t0);
  if (!customer || !!cart.customer_id) {
    return;
  }
  let t1;
  if ($[2] !== t) {
    t1 = async () => {
      try {
        setIsPending(true);
        setActionText(`${t("Transferring")}...`);
        await transferCart();
      } catch {
        setActionText(t("Run transfer again"));
        setIsPending(false);
      }
    };
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSubmit = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ExclamationCircleSolid className="inline" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("Something went wrong when we tried to transfer your cart");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span className="flex items-center gap-1">{t2}{t3}</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span>·</span>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== actionText || $[11] !== handleSubmit || $[12] !== isPending) {
    t6 = <Button variant="transparent" className="hover:bg-transparent active:bg-transparent focus:bg-transparent disabled:text-orange-500 text-orange-950 p-0 bg-transparent" size="base" disabled={isPending} onClick={handleSubmit}>{actionText}</Button>;
    $[10] = actionText;
    $[11] = handleSubmit;
    $[12] = isPending;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <div className="flex items-center justify-center small:p-4 p-2 text-center bg-orange-300 small:gap-2 gap-1 text-sm mt-2 text-orange-800"><div className="flex flex-col small:flex-row small:gap-2 gap-1 items-center">{t4}{t5}{t6}</div></div>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export default CartMismatchBanner;